/* leverege-molten no-export */
/**
 * Causes the data fetching component to load data
 * @async
 * @callback loadData
 * 
 */

export default class AbstractQueryTrigger {
  /**
   * 
   * @param {Object} opts The options passed to the delegate from the data fetching component
   * @param {loadData} opts.loadData Function to call to cause data loading
   * @param {string} opts.objectType The objectType loaded by the data fetching component
   * @param {string} opts.path The path within the ui where the data fetching component is mounted (ex. "location.vehicles")
   * @param {string} opts.client The client name of the data fetching component
   * @param {import('@leverege/molten/data-source').Relationship} opts.relationship The relationship object for the current data loading component
   * @param {import('@leverege/value-cache').ValuesCache} opts.caches A caches object tied to the data fetching component to use for storing data between requests
   * @param {Object} cxt An arbitrary context containing object passed by the data fetching component
   */
  constructor(opts, cxt) {
    this.options = opts;
    this.context = cxt;
  }

  /**
   * @async
   * Run by the data fetching component upon its own mounting, giving the delegate an opportunity to initialize any state/listeners/timers
   */
  async init() {
    return Promise.resolve();
  }

  /**
   * Run by the data fetching component upon its own mounting, giving the delegate an opportunity to clean up any state/listeners/timers
   */
  cleanup() {}

  /**
   * @async
   * Run by the data fetching component prior to fetching data
   */
  async preQuery() {
    return Promise.resolve();
  }

  /**
   * @async
   * Run by the data fetching component attempting to fetch data
   * @param {Error} error The error encountered during a query for data (null if the request was successful)
   * @returns 
   */
  async postQuery(error) {
    return Promise.resolve();
  }
}